import { useMe } from "src/context/MeContext";
import { getBotName, getProductName } from "src/utils/brandTheme";

export function useProductBranding() {
  const me = useMe();
  const brandTheme = me.organization?.brandTheme;
  return {
    productName: getProductName(brandTheme),
    botName: getBotName(brandTheme),
    brandTheme: brandTheme ?? "TIERZERO",
  };
}
